import { Text } from 'react-native'
import React from 'react'


const BoldText = (props) => (
  <Text style={{ fontWeight: 'bold' }}>{props.children}</Text>
)

export default BoldText
